import AllCheckMyemsContainer from "../containers/AllCheckMyemsContainer";

const AllCheckMyemsPage = () => {

    return <AllCheckMyemsContainer/>
}

export default AllCheckMyemsPage